import React from "react";
import styles from "../styles/components/MobileSupportError.css";
import WevoIcon from "../assets/svg/wevo_logo_wide_color.svg";
import MobileErrorIcon from "../assets/svg/mobile_error_icon.svg";

const MobileSupportError = () => (
    <div className={styles.container}>
        <img
            src={MobileErrorIcon}
            className={styles.mobileErrorIcon}
            alt="ie"
        />
        <h1 className={styles.header}>Whoops!</h1>
        <p className={styles.subheader}>
            Our platform does not currently support mobile devices. Please
            launch WEVO in a desktop browser.
        </p>
        <div className={styles.footer}>
            <p className={styles.footerText}>
                For additional help, please call us at (888) 835-6828 or email
                <a
                    href="mailto:support@wevoconversion.com"
                    className={styles.footerLink}
                >
                    {" "}
                    support@wevoconversion.com
                </a>
            </p>
            <img src={WevoIcon} className={styles.wevoIcon} />
        </div>
    </div>
);

export default MobileSupportError;



// WEBPACK FOOTER //
// ./src/components/MobileSupportError.js